import React, { useState } from "react";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import Autocomplete from "@mui/material/Autocomplete";

const DEFAULT_OPTIONS = [10, 15, 20, 30, 50];

function RowsPerPageSelector({ value, onChange }) {
  const [customValue, setCustomValue] = useState("");

  const handleSelect = (event, newValue) => {
    if (newValue !== null && !isNaN(Number(newValue))) {
      onChange(Number(newValue));
      setCustomValue("");
    }
  };

  const handleInputChange = (e) => {
    const val = e.target.value.replace(/[^0-9]/g, "");
    setCustomValue(val);
    if (val && !isNaN(Number(val))) {
      onChange(Number(val));
    }
  };

  return (
    <MDBox display="flex" alignItems="center" gap={1}>
      <Autocomplete
        disableClearable
        options={DEFAULT_OPTIONS.map((n) => n.toString())}
        value={DEFAULT_OPTIONS.includes(value) ? value.toString() : ""}
        onChange={handleSelect}
        size="small"
        sx={{ width: "6rem" }}
        renderInput={(params) => <MDInput {...params} label="عدد الصفوف" />}
        isOptionEqualToValue={(option, val) => option === val}
      />
      <MDInput
        type="number"
        label="مخصص"
        size="small"
        value={customValue}
        onChange={handleInputChange}
        sx={{ width: "5rem" }}
        inputProps={{ min: 1 }}
      />
    </MDBox>
  );
}

RowsPerPageSelector.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default RowsPerPageSelector;
